// import { BaSeLoadingPage } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { PublicRoutes } from './routes/public';
import { ClientRoutes } from './routes/client';
import { AdminRoutes } from './routes/admin';

export const Routes = () => {
  return (
    <Sebrae.Routes
      routes={[...PublicRoutes, ...ClientRoutes, ...AdminRoutes]}
    />
  );
};
